// what is the exact difference to loadmoreStart? Could it be handled in one function?
export function loadingSpinner(parent, show = true) {
  const spinner = parent.querySelector("[data-spinner]");
  if (spinner) {
    // Can we do this based on parent class we add?
    show ? jQuery(spinner).show() : jQuery(spinner).hide();
  }

  show ? parent.classList.add("loading") : parent.classList.remove("loading");
}

export function loadmoreSpinner(parent, show = true) {
  const spinner = parent.querySelector("[data-loadmore-spinner]");

  if (spinner) {
    show ? jQuery(spinner).show() : jQuery(spinner).hide();
  }

  show ? parent.classList.add("loadmore") : parent.classList.remove("loadmore");
}
